export const ENDPOINT_BANNER_LEGACY = '/backoffice/banner';
export const ENDPOINT_BANNER_CG3 = '/backoffice/banner/personalized';

export const BACKOFFICE_BANNER_QUERY_KEY = 'BackofficeBanners';
export const BACKOFFICE_BANNER_LEGACY_QUERY_KEY = 'BackofficeBannersLegacy';
export const BANNER_PAGE_SIZE = 25;
